import React, { ReactNode } from 'react';
import {Link, useLocation} from 'react-router-dom';
import { ReactComponent as DefaultIcon } from '../../images/defaultNav.svg';
import styled from 'styled-components';
import { onClickOrLink } from '../../app/util';

const MenuLink = styled(Link)`
	height: 50px;
	display: flex;
	align-items: center;
`;

const NavLink = styled.span`
	font-size: 16pt;
	color: #FFFFFF;
`;

const Icon = styled.span`
	svg {
		display: inline-flex;
		transform: translateY(2px);
		padding: 0 32px 0 20px;
		width: 18px;
		height: 18px;
	}
`;

interface MenuItemProps {
	children?: ReactNode;
	icon: ReactNode;
	matchRoutes?: string[];
	modifyChildrenOnClick?: (onClick: { to?: string }, routeParams: { key?: string }) => {},
	onClick: { to: string } | { href: string } |  Function;
	renderChildrenIf?: (route: string) => boolean,
	text: string;
}

const MenuItem = ({
	onClick,
	icon,
	text,
}: MenuItemProps) => {
	const linkProps = onClickOrLink(onClick);
	const location = useLocation();
	
	// Extract the key from the current URL path
	const pathParts = location.pathname.split('/');
	const electionKeyIndex = pathParts.findIndex(part => part === 'elections') + 1;
	const electionKey = electionKeyIndex > 0 && electionKeyIndex < pathParts.length ? pathParts[electionKeyIndex] : undefined;
	
	// Only try to use the key parameter if the link contains SELECTED_ELECTION
	const needsElectionKey = typeof linkProps?.to === 'string' && linkProps.to.includes('SELECTED_ELECTION');

	const linkPropsNew = {
		...linkProps,
		to: needsElectionKey && electionKey ? linkProps?.to?.replace('SELECTED_ELECTION', electionKey) : linkProps?.to
	}

	return (
		<MenuLink
			to={linkPropsNew?.to}
			onClick={linkPropsNew?.onClick}
			key={text}>
			<Icon>
				{ (icon) ? ( icon ): <DefaultIcon /> }
			</Icon>
			<NavLink>{ text }</NavLink>
		</MenuLink>
	)
}

export default MenuItem;
